/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2518
 */

var r = require(/* 728 */"../../../../../../253/2568/2569/2570/994/2490/1177/728/index")(require(/* 502 */"../../../../../../253/2588/1461/2585/502/index"), "DataView")
module.exports = r
